import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { SkeletonLoader } from '@grandvisionhq/elements';

const LoadingIndication = ()=>/*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: "loading-indication"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        fill: "currentColor",
        y: "0",
        height: "100%"
    })))
;
const LoadingStoreCard = (_param)=> {
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('loading-store-card', className)
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "first-row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "first-row__left"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null)), /*#__PURE__*/ React.createElement("div", {
        className: "first-row__right"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null))), /*#__PURE__*/ React.createElement("div", {
        className: "second-row"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null)), /*#__PURE__*/ React.createElement("div", {
        className: "third-row"
    }, /*#__PURE__*/ React.createElement(LoadingIndication, null)));
};
var LoadingStoreCard$1 = LoadingStoreCard;

export { LoadingStoreCard$1 as default };
//# sourceMappingURL=LoadingStoreCard.js.map
